import { defineStyleConfig, extendTheme } from "@chakra-ui/react";
import { inputTheme } from "./theme/Input";
import { menuTheme } from "./theme/Menu";
import { selectTheme } from "./theme/Select";
import { accordionTheme } from "./theme/Accordion";
import { tabsTheme } from "./theme/Tabs";
import { listTheme } from "./theme/List";

var Button = defineStyleConfig({
  baseStyle: {
    fontWeight: "500",
    rounded: "none",
    fontFamily: `"Inter", sans-serif`,
    boxSizing: "border-box",
  },
  sizes: {
    xl: {
      fontSize: "3xl",
      py: 8,
    },
  },
  variants: {
    "solid-dark": (props) => {
      return {
        bg: `${props.colorScheme}.500`,
        textColor: "gray.900",
      };
    },
    outline: (props) => ({
      borderColor: `${props.colorScheme}.500`,
      color: `${props.colorScheme}.500`,
    }),
    subtle: (props) => {
      return {
        bg: `${props.colorScheme}.50`,
        textColor: `${props.colorScheme}.500`,
      };
    },
  },
});

var theme = extendTheme({
  styles: {
    global: {
      a: {
        fontFamily: `"Inter", sans-serif`,
      },
      button: {
        span: {
          fontFamily: `"Inter", sans-serif`,
        },
      },
    },
  },
  fonts: {
    heading: `'AeonikPro', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  colors: {
    flatteredFlamingo: {
      50: "#FBE2DE",
      100: "#F9CFC9",
      200: "#F6B6AD",
      300: "#F39E92",
      400: "#F08677",
      500: "#ED6E5C",
      600: "#C55C4D",
      700: "#9E493D",
      800: "#77372E",
      900: "#4F251F",
    },
    prussianBlue: {
      50: "#D0D6D9",
      100: "#B1BBC0",
      200: "#8A98A1",
      300: "#637682",
      400: "#3C5462",
      500: "#153243",
      600: "#122A38",
      700: "#0E212D",
      800: "#0B1922",
      900: "#071116",
    },
    galleonBlue: {
      50: "#DAEAF3",
      100: "#C1DCEB",
      200: "#A1CAE1",
      300: "#82B8D8",
      400: "#63A7CE",
      500: "#4495C4",
      600: "#397CA3",
      700: "#2D6383",
      800: "#224B62",
      900: "#173241",
    },
    lavender: {
      50: "#EEE6F8",
      100: "#E2D5F4",
      200: "#D3C0EE",
      300: "#C5ACE8",
      400: "#B697E3",
      500: "#A882DD",
      600: "#8C6CB8",
      700: "#705793",
      800: "#54416F",
      900: "#382B4A",
    },
    white: "#FEFEFE",
    lawnGreen: {
      50: "#EAFDDC",
      100: "#DCFCC5",
      200: "#CAFAA7",
      300: "#B9F88A",
      400: "#A7F76D",
      500: "#96F550",
      600: "#7DCC43",
      700: "#64A335",
      800: "#4B7B28",
      900: "#32521B",
    },
    black: "#121212",
    inactiveTextColor: "#949494",
  },
  components: {
    Button,
    Text: {
      baseStyle: {
        fontFamily: `"Inter", sans-serif`,
      },
    },
    Accordion: accordionTheme,
    Input: inputTheme,
    Select: selectTheme,
    Menu: menuTheme,
    Tabs: tabsTheme,
    List: listTheme,
  },
  breakpoints: {
    width1428px: '1428px',
    width1279px: '1279px',
  }
});

export default theme;
